// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './vuex/store'
Vue.use(Vuex);
import VueResource from 'vue-resource';
Vue.use(VueResource);

import Toast from './components/toastjs'
Vue.use(Toast);
import Confirm from './components/confirmjs'
Vue.use(Confirm);
import Message from './components/messagejs'
Vue.use(Message);
import Loading from './components/loadingjs'
Vue.use(Loading);

import select from './components/select'
import selectOption from './components/selectOption'
import radio from './components/radio'
import checkBox from './components/checkBox'
import checkBoxGroup from './components/checkBoxGroup'
import timePicker from './components/timePicker'
import table from './components/table'
import tableItem from './components/tableItem'
import pages from './components/pages'
import tree from './components/tree'

Vue.component('hz-select',select);
Vue.component('hz-select-option',selectOption);
Vue.component('hz-radio',radio);
Vue.component('hz-checkbox',checkBox);
Vue.component('hz-checkbox-group',checkBoxGroup);
Vue.component('hz-time-picker',timePicker);
Vue.component('hz-table',table);
Vue.component('hz-table-item',tableItem);
Vue.component('hz-page',pages);
Vue.component('hz-tree',tree);


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js